import React from 'react';
import { Colors as C } from '../../constants/Colors.js';

const TOOLTIP = 'Partner verificado';

/**
 * Icono compacto: disco de vinilo + check verde (partner DreamVinyl aprobado).
 * Tooltip nativo al pasar el ratón.
 */
export default function PartnerVerifiedBadge({
  size = 18,
  title = TOOLTIP,
  style,
  className,
}) {
  const s = Number(size) || 18;

  return (
    <span
      className={className}
      title={title}
      role="img"
      aria-label={title}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        lineHeight: 0,
        cursor: 'default',
        verticalAlign: 'middle',
        ...style,
      }}
    >
      <svg width={s} height={s} viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9.25" fill="rgba(83,74,183,0.45)" stroke="rgba(175,169,236,0.55)" strokeWidth="0.75" />
        <circle cx="12" cy="12" r="6.2" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="0.5" />
        <circle cx="12" cy="12" r="2.35" fill="#0b0b10" stroke="rgba(255,255,255,0.2)" strokeWidth="0.4" />
        <path
          d="M12 5.2a6.8 6.8 0 016.8 6.8"
          fill="none"
          stroke="rgba(200,168,75,0.35)"
          strokeWidth="0.45"
          strokeLinecap="round"
        />
        <circle cx="17.2" cy="17.2" r="5.1" fill={C.green} />
        <path
          d="M14.4 17.1l1.6 1.6 3.4-3.5"
          fill="none"
          stroke="#0b0b10"
          strokeWidth="1.65"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
